import { axiosClient } from "@/shared/api/axios-client";
import type { Paginado } from "@/lib/types";

export interface SolicitudEnEsperaDeCfdi {
  id: string;
  numeroSolicitud: number;
  folio: string;
  organizacionNombre: string | null;
  proveedorNumero: number | null;
  proveedorRazonSocial: string | null;
  fechaPago: string | null;
  esperaCfdiFechaLimite: string;
  esperaCfdiVencida: boolean;
  esperaCfdiAvisoEnviadoAt: string | null;
}

export interface BuscarEnEsperaParams {
  folio?: string;
  page?: number;
  pageSize?: number;
}

export const enEsperaCfdiApi = {
  listar: (params: BuscarEnEsperaParams = {}) =>
    axiosClient
      .get<Paginado<SolicitudEnEsperaDeCfdi>>("/api/solicitudes/en-espera-cfdi", { params })
      .then((r) => r.data),
};
